import React, { createContext, useContext, useState } from 'react';

const ConfirmContext = createContext();

export const useConfirm = () => useContext(ConfirmContext);

const ConfirmProvider = ({ children }) => {
  const [confirmState, setConfirmState] = useState({
    message: '',
    resolve: null,
    open: false,
  });

  const confirm = (message) => {
    return new Promise((resolve) => {
      setConfirmState({ message, resolve, open: true });
    });
  };

  const handleConfirm = (result) => {
    confirmState.resolve(result);
    setConfirmState({ ...confirmState, open: false });
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}

      {confirmState.open && (
        <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center" style={{ zIndex: 1056 }}>
          <div className="bg-white p-4 rounded shadow" style={{ width: 300 }}>
            <p className="mb-3">{confirmState.message}</p>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-secondary" onClick={() => handleConfirm(false)}>Cancel</button>
              <button className="btn " style={{backgroundColor:'#644D9F',color:"white"}} onClick={() => handleConfirm(true)}>OK</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

export default ConfirmProvider;
